export const costs = [
  'Prepari ogni lezione di geologia da zero, cercando materiale sparso su internet',
  'Spiegare placche, terremoti e ciclo delle rocce senza immagini chiare è difficile',
  'Non hai attività, progetti e verifiche pronte da usare in classe',
  'Ti manca tempo per programmare unità didattiche complete e coerenti',
];
